import { render } from "./SwitchToArticle.vue?vue&type=template&id=1ba2ced3&scoped=true"
import script from "./SwitchToArticle.vue?vue&type=script&lang=js"
export * from "./SwitchToArticle.vue?vue&type=script&lang=js"

import "./SwitchToArticle.vue?vue&type=style&index=0&id=1ba2ced3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba2ced3"]])

export default __exports__